import {
  GQLBonusSet,
  GQLProduct,
  GQLProductCollectionItems,
  GQLSectionBannerSlideProduct,
} from '~/graphql/__generated__/interfaces'

export function isGQLProduct(
  object: GQLProductCollectionItems
): object is GQLProduct {
  return object.__typename === 'Product'
}

export function isGQLBonusSet(
  object: GQLProductCollectionItems
): object is GQLBonusSet {
  return object.__typename === 'BonusSet'
}

export function isGQLSectionBannerSlideProduct(
  object: GQLProductCollectionItems
): object is GQLSectionBannerSlideProduct {
  return object.__typename === 'SectionBannerSlideProduct'
}
